<template>
  <nav class="navbar navbar-expand-lg navbar-light" style="background-color: #FFD199;">
    <router-link :to="{ name: 'Writer' }" class="navbar-brand">
        <img src="@/assets/logo.png" alt="logo" width="32" />
        Pro Editor
      </router-link>
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
       <i class="fad fa-bars"></i>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
       <ul class="navbar-nav mr-auto">
          <li class="nav-item">
            <a class="nav-link" href="#">Courses</a>
          </li>
          <li class="nav-item">
            <a class="nav-link active" aria-current="page" href="#">Post Writer VA</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#">Blog</a>
          </li>
           <li class="nav-item">
            <a class="nav-link" href="#">Apply for a job</a>
          </li>
        </ul>
    </div>
  </nav>
</template>

<script>
export default {
  name: "Navbar",
};
</script>

<style>
.navbar-brand {
  color: #373737;
}
</style>